import { Card, CardContent, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const FileSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('border-b', 'flex-between', 'gap-3', 'px-3 py-2', className);

	// Render
	return (
		<Card className={rootClassName}>
			<span className='flex-start grow gap-3 w-full'>
				<CardHeader className='aspect-[1/1] rounded-control shrink-0 w-7'>
					<Skeleton className='leading-[inherit]' />
				</CardHeader>
				<CardContent className='gap-1 min-w-0 w-full'>
					<CardTitle className='w-2/3'>
						<Skeleton />
					</CardTitle>
				</CardContent>
			</span>
		</Card>
	);
};
export { FileSkeleton };
